import InputDayMonth from "./InputDayMonth";
export default InputDayMonth;



// WEBPACK FOOTER //
// ./src/commonComponents/InputDayMonth/index.js